import React, { useState } from 'react'
import { isManualPageAvailable, isStaff } from '../utils/helpers'
import MenuItem from './sidebar/menu_item'
import {
  NAVIGATION_ID_ACCESS_CODES,
  NAVIGATION_ID_INSIGHTS,
  NAVIGATION_ID_MANUAL_AML,
  NAVIGATION_ID_USERS,
  navigationItems,
  STORAGE_TYPE_LOCAL,
} from '../config'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import MenuHeader from './sidebar/menu_header'
import { APP_USER_NAME } from '../middleware/api'
import MenuTreeParser from '../utils/menu_tree_parser'
import StorageProviderFactory from '../managers/storage_provider_factory'

const SideBar = (props) => {
  const [isDropdownOn, setIsDropdownOn] = useState(false)

  const handleProfileMenu = (e) => {
    setIsDropdownOn(false)
    handleNavClick('/profile')
  }

  const handleNavClick = (url) => {
    const { pathname, navigateToPage } = props
    if (pathname === url) {
      return
    }
    navigateToPage(url)
  }

  const handleInsightsClick = () => {
    setIsDropdownOn(false)
    handleNavClick('/insights')
  }

  const isMenuActive = (path) => {
    const { pathname } = props
    let currentBasePath = '/'
    const arr = pathname.split('/').filter((item) => item !== '')
    if (arr.length > 0) {
      currentBasePath = '/' + arr[0]
    }

    const menuTree = MenuTreeParser.parse(navigationItems, currentBasePath, [])
    let menuPaths = []
    if (menuTree) {
      menuPaths = menuTree.map((item) => item.path)
    }
    return menuPaths.indexOf(path) !== -1
  }

  const filterNavigationItems = ({ id, enabled }) => {
    const { user } = props
    if (id === NAVIGATION_ID_INSIGHTS) {
      return isStaff(user)
    }

    if (id === NAVIGATION_ID_ACCESS_CODES) {
      return isStaff(user)
    }

    if (id === NAVIGATION_ID_USERS) {
      return user && user.groups.includes('client_admins')
    }

    if (id === NAVIGATION_ID_MANUAL_AML) {
      return isManualPageAvailable(user)
    }
    return enabled
  }
  const { onLogoutClick, user, logo, company } = props

  return (
    <nav className='navbar-default navbar-static-side'>
      <div className='sidebar-collapse'>
        <ul className='nav' id='side-menu' style={{ backgroundColor: '#2f4050', height: '2000px' }}>
          <MenuHeader
            user={user}
            handleLogoutClick={onLogoutClick}
            handleInsightsClick={handleInsightsClick}
            handleProfileMenu={handleProfileMenu}
            isDropdownOn={isDropdownOn}
            logo={logo}
            company={company}
            username={StorageProviderFactory.create(STORAGE_TYPE_LOCAL).getItem(APP_USER_NAME)}
          />
          {navigationItems.filter(filterNavigationItems).map((item, i) => (
            <MenuItem
              handleNavClick={handleNavClick}
              key={i}
              path={item.path}
              isActive={isMenuActive(item.path)}
              title={item.title}
              iconClass={item.iconClass}
              subItem={item.subItem}
              // TODO: obsolete code
              // eslint-disable-next-line react/no-string-refs,react/no-children-prop
              children={item.children}
            />
          ))}
        </ul>
      </div>
    </nav>
  )
}

const mapStateToProps = (state, ownProps) => ({
  pathname: ownProps.location.pathname,
})

const mapDispatchToProps = (dispatch, ownProps) =>
  bindActionCreators(
    {
      navigateToPage: (url) => ownProps.history.push(url),
    },
    dispatch
  )

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SideBar))
